const TERMINAL_DELETED = new Set(['DELETED']);
const TERMINAL_RETAINED = new Set(['RETAINED_RESTRICTED']);
const NOT_COLLECTED = new Set(['NOT_PRESENT']);
const RETRY = new Set(['DELETE_FAILED', 'FAILED', 'RETRY_PENDING']);
const MANUAL = new Set(['MANUAL_REVIEW']);

export function revocationItemBucket(item) {
  const status = String(item?.status || '').toUpperCase();
  const resourceType = String(item?.resource_type || '').toLowerCase();
  if (resourceType === 'system_evidence' || item?.bucket === 'system_evidence') return 'system_evidence';
  if (NOT_COLLECTED.has(status) || resourceType === 'policy_target' || item?.bucket === 'not_collected') return 'not_collected';
  if (TERMINAL_DELETED.has(status)) return 'deleted';
  if (TERMINAL_RETAINED.has(status)) return 'retained';
  if (RETRY.has(status)) return 'retry_review';
  if (MANUAL.has(status)) return 'retry_review';
  return 'pending';
}

export function isActualRevocationResource(item) {
  return !['not_collected', 'system_evidence'].includes(revocationItemBucket(item));
}

export function summarizeRevocationItems(items = []) {
  const result = {
    actual: 0,
    deleted: 0,
    retained: 0,
    not_collected: 0,
    system_evidence: 0,
    retry_review: 0,
    pending: 0,
  };
  for (const item of items) {
    const bucket = revocationItemBucket(item);
    result[bucket] += 1;
    if (isActualRevocationResource(item)) result.actual += 1;
  }
  return result;
}

export function normalizeRunStatus(status) {
  const value = String(status || '').toUpperCase();
  if (['SUCCESS', 'COMPLETED', 'COMPLETED_DELETED', 'COMPLETED_WITH_RETENTION'].includes(value)) return 'success';
  if (['FAILED', 'RETRY_PENDING', 'MANUAL_REVIEW'].includes(value)) return 'failed';
  if (['RUNNING', 'PROCESSING', 'PARTIAL'].includes(value)) return 'running';
  return 'pending';
}
